import { injectable, inject } from 'inversify';
import type { ITenantRepository, TenantFormData } from '@/domain/repositories/ITenantRepository';
import { Tenant } from '@/domain/entities/Tenant';
import { TYPES } from '@/di/tokens';

@injectable()
export class UpdateTenantAction {
  constructor(
    @inject(TYPES.ITenantRepository) private tenantRepository: ITenantRepository
  ) {}

  async execute(id: number, data: TenantFormData): Promise<Tenant> {
    return await this.tenantRepository.update(id, data);
  }
}
